export function appendQueryParam(url: string, key: string, value?: string | null): string {
  if (!url || !key || value == null) return url;
  try {
    const u = new URL(url);
    u.searchParams.set(key, String(value));
    return u.toString();
  } catch {
    return url;
  }
}


